import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { HeaderComponent } from './components/header/header.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LicenceDialogComponent } from './components/licence-dialog/licence-dialog.component';
import { GenerateAllTerminalComponent } from './components/generate-all-terminal/generate-all-terminal.component';
import { ClubSelectComponent } from './components/club-select/club-select.component';
import { ArabicKeyboardComponent } from './components/arabic-keyboard/arabic-keyboard.component';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { ArabicOnlyDirective } from './directives/arabic-only.directive';
import { DemandeLabelPipe } from './pipes/demande-label.pipe';

@NgModule({
  declarations: [
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    LicenceDialogComponent,
    GenerateAllTerminalComponent,
    ClubSelectComponent,
    ArabicKeyboardComponent,
    RichTextEditorComponent,
    ArabicOnlyDirective,
    DemandeLabelPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    EditorModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    LicenceDialogComponent,
    GenerateAllTerminalComponent,
    ClubSelectComponent,
    ArabicKeyboardComponent,
    RichTextEditorComponent,
    ArabicOnlyDirective,
    DemandeLabelPipe,
  ]
})
export class SharedModule { }
